import { __rest } from "tslib";
import React from 'react';
const ShellComponentHOC = (props) => {
    const { data } = props;
    const { component: ShellContainer } = data, otherProps = __rest(data, ["component"]);
    return <ShellContainer {...otherProps}/>;
};
export default ShellComponentHOC;
